"use client";

import { useEffect, useRef } from "react";
import gsap from "gsap";

export default function GSAPAnimationWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const wrapperRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      wrapperRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 0.6, ease: "power3.out" }
    );
  }, []);

  return <div ref={wrapperRef}>{children}</div>;
}
